import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;
export const api = axios.create({ baseURL: API, withCredentials: true });
if (process.env.REACT_APP_DESIGN_PREVIEW === "true") {
  api.interceptors.request.use(() => { throw new Error("Please contact the LENIS team for assistance."); });
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// catalog
export const getProducts = () => api.get("/products").then((r) => r.data);
export const getProduct = (id) => api.get(`/products/${id}`).then((r) => r.data);

// forms
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitQuiz = (answers, email) => api.post("/quiz", { answers, email }).then((r) => r.data);
export const getBundle = () => api.get("/bundle").then((r) => r.data);

// auth
export const authRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const verifyRegistration = (payload) => api.post("/auth/verify-registration", payload).then((r) => r.data);
export const authLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authSession = (sessionId) =>
  api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);

// payments
export const startCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// account
export const getAccountOrders = () => api.get("/account/orders").then((r) => r.data);
export const getSubscriptions = () => api.get("/account/subscriptions").then((r) => r.data);
export const cancelSubscription = (subId) => api.post(`/account/subscriptions/${subId}/cancel`).then((r) => r.data);


